
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/api',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/api/',
            getPage: () => import(
              /* webpackChunkName: "api" */
              '/work/api-documentation/_site_tmp/_api.js'
            ),
            
            
          },{
            path: '/api/accounts/',
            getPage: () => import(
              /* webpackChunkName: "api-accounts" */
              '/work/api-documentation/_site_tmp/_api_accounts.js'
            ),
            
            
          },{
            path: '/api/accounts/changelog/',
            getPage: () => import(
              /* webpackChunkName: "api-accounts-changelog" */
              '/work/api-documentation/_site_tmp/_api_accounts_changelog.js'
            ),
            
            
          },{
            path: '/api/accounts/tokens/',
            getPage: () => import(
              /* webpackChunkName: "api-accounts-tokens" */
              '/work/api-documentation/_site_tmp/_api_accounts_tokens.js'
            ),
            
            
          },{
            path: '/api/changelog/',
            getPage: () => import(
              /* webpackChunkName: "api-changelog" */
              '/work/api-documentation/_site_tmp/_api_changelog.js'
            ),
            
            
          },{
            path: '/api/legacy/analytics/',
            getPage: () => import(
              /* webpackChunkName: "api-legacy-analytics" */
              '/work/api-documentation/_site_tmp/_api_legacy_analytics.js'
            ),
            
            
          },{
            path: '/api/legacy/directions-v4/',
            getPage: () => import(
              /* webpackChunkName: "api-legacy-directions-v4" */
              '/work/api-documentation/_site_tmp/_api_legacy_directions-v4.js'
            ),
            
            
          },{
            path: '/api/legacy/map-matching-v4/',
            getPage: () => import(
              /* webpackChunkName: "api-legacy-map-matching-v4" */
              '/work/api-documentation/_site_tmp/_api_legacy_map-matching-v4.js'
            ),
            
            
          },{
            path: '/api/legacy/maps/',
            getPage: () => import(
              /* webpackChunkName: "api-legacy-maps" */
              '/work/api-documentation/_site_tmp/_api_legacy_maps.js'
            ),
            
            
          },{
            path: '/api/maps/',
            getPage: () => import(
              /* webpackChunkName: "api-maps" */
              '/work/api-documentation/_site_tmp/_api_maps.js'
            ),
            
            
          },{
            path: '/api/maps/changelog/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-changelog" */
              '/work/api-documentation/_site_tmp/_api_maps_changelog.js'
            ),
            
            
          },{
            path: '/api/maps/datasets/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-datasets" */
              '/work/api-documentation/_site_tmp/_api_maps_datasets.js'
            ),
            
            
          },{
            path: '/api/maps/fonts/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-fonts" */
              '/work/api-documentation/_site_tmp/_api_maps_fonts.js'
            ),
            
            
          },{
            path: '/api/maps/mapbox-tiling-service/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-mapbox-tiling-service" */
              '/work/api-documentation/_site_tmp/_api_maps_mapbox-tiling-service.js'
            ),
            
            
          },{
            path: '/api/maps/raster-tiles/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-raster-tiles" */
              '/work/api-documentation/_site_tmp/_api_maps_raster-tiles.js'
            ),
            
            
          },{
            path: '/api/maps/static-images/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-static-images" */
              '/work/api-documentation/_site_tmp/_api_maps_static-images.js'
            ),
            
            
          },{
            path: '/api/maps/static-tiles/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-static-tiles" */
              '/work/api-documentation/_site_tmp/_api_maps_static-tiles.js'
            ),
            
            
          },{
            path: '/api/maps/styles/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-styles" */
              '/work/api-documentation/_site_tmp/_api_maps_styles.js'
            ),
            
            
          },{
            path: '/api/maps/tilequery/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-tilequery" */
              '/work/api-documentation/_site_tmp/_api_maps_tilequery.js'
            ),
            
            
          },{
            path: '/api/maps/uploads/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-uploads" */
              '/work/api-documentation/_site_tmp/_api_maps_uploads.js'
            ),
            
            
          },{
            path: '/api/maps/vector-tiles/',
            getPage: () => import(
              /* webpackChunkName: "api-maps-vector-tiles" */
              '/work/api-documentation/_site_tmp/_api_maps_vector-tiles.js'
            ),
            
            
          },{
            path: '/api/navigation/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation" */
              '/work/api-documentation/_site_tmp/_api_navigation.js'
            ),
            
            
          },{
            path: '/api/navigation/changelog/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-changelog" */
              '/work/api-documentation/_site_tmp/_api_navigation_changelog.js'
            ),
            
            
          },{
            path: '/api/navigation/directions/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-directions" */
              '/work/api-documentation/_site_tmp/_api_navigation_directions.js'
            ),
            
            
          },{
            path: '/api/navigation/ev-platform/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-ev-platform" */
              '/work/api-documentation/_site_tmp/_api_navigation_ev-platform.js'
            ),
            
            
          },{
            path: '/api/navigation/http-post/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-http-post" */
              '/work/api-documentation/_site_tmp/_api_navigation_http-post.js'
            ),
            
            
          },{
            path: '/api/navigation/isochrone/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-isochrone" */
              '/work/api-documentation/_site_tmp/_api_navigation_isochrone.js'
            ),
            
            
          },{
            path: '/api/navigation/map-matching/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-map-matching" */
              '/work/api-documentation/_site_tmp/_api_navigation_map-matching.js'
            ),
            
            
          },{
            path: '/api/navigation/matrix/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-matrix" */
              '/work/api-documentation/_site_tmp/_api_navigation_matrix.js'
            ),
            
            
          },{
            path: '/api/navigation/optimization-v1/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-optimization-v1" */
              '/work/api-documentation/_site_tmp/_api_navigation_optimization-v1.js'
            ),
            
            
          },{
            path: '/api/navigation/optimization/',
            getPage: () => import(
              /* webpackChunkName: "api-navigation-optimization" */
              '/work/api-documentation/_site_tmp/_api_navigation_optimization.js'
            ),
            
            
          },{
            path: '/api/overview/',
            getPage: () => import(
              /* webpackChunkName: "api-overview" */
              '/work/api-documentation/_site_tmp/_api_overview.js'
            ),
            
            
          },{
            path: '/api/private-beta/fleet-manager/',
            getPage: () => import(
              /* webpackChunkName: "api-private-beta-fleet-manager" */
              '/work/api-documentation/_site_tmp/_api_private-beta_fleet-manager.js'
            ),
            
            
          },{
            path: '/api/search/',
            getPage: () => import(
              /* webpackChunkName: "api-search" */
              '/work/api-documentation/_site_tmp/_api_search.js'
            ),
            
            
          },{
            path: '/api/search/category-search/',
            getPage: () => import(
              /* webpackChunkName: "api-search-category-search" */
              '/work/api-documentation/_site_tmp/_api_search_category-search.js'
            ),
            
            
          },{
            path: '/api/search/changelog/',
            getPage: () => import(
              /* webpackChunkName: "api-search-changelog" */
              '/work/api-documentation/_site_tmp/_api_search_changelog.js'
            ),
            
            
          },{
            path: '/api/search/geocoding-v6/',
            getPage: () => import(
              /* webpackChunkName: "api-search-geocoding-v6" */
              '/work/api-documentation/_site_tmp/_api_search_geocoding-v6.js'
            ),
            
            
          },{
            path: '/api/search/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "api-search-geocoding" */
              '/work/api-documentation/_site_tmp/_api_search_geocoding.js'
            ),
            
            
          },{
            path: '/api/search/managed-federation/',
            getPage: () => import(
              /* webpackChunkName: "api-search-managed-federation" */
              '/work/api-documentation/_site_tmp/_api_search_managed-federation.js'
            ),
            
            
          },{
            path: '/api/search/optional-params-table/',
            getPage: () => import(
              /* webpackChunkName: "api-search-optional-params-table" */
              '/work/api-documentation/_site_tmp/_api_search_optional-params-table.js'
            ),
            
            
          },{
            path: '/api/search/search-box/',
            getPage: () => import(
              /* webpackChunkName: "api-search-search-box" */
              '/work/api-documentation/_site_tmp/_api_search_search-box.js'
            ),
            
            
          },{
            path: '/api/search/search/',
            getPage: () => import(
              /* webpackChunkName: "api-search-search" */
              '/work/api-documentation/_site_tmp/_api_search_search.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };